export const BASE_URL_API = process.env.REACT_APP_BLOG_API_URL;

//Panel
export const BASE_URL = process.env.REACT_APP_BASE_URL;
// export const BASE_URL = "http://192.168.11.33:3001";
// export const BASE_URL_API_PANEL = "http://192.168.11.33:3002/api/"
export const BASE_URL_API_PANEL = process.env.REACT_APP_PANEL_API_URL;
// export const BASE_URL_API = "http://192.168.13.230:3002/api/"

export const REQUIRED_FIELD_MESSAGE = "فیلد ضروری";

//Status Data
export const FlightTicketStates = {
  0: { children: "پرداخت نشده", className: "color-red-c bg-light-red-c" },
  1: {
    children: "نیاز به بررسی فنی",
    className: "color-purple-c bg-light-purple-c",
  },
  3: { children: "موفق", className: "bg-light-green-c color-green-c" },
  4: {
    children: "نیاز به بررسی فنی",
    className: "color-purple-c bg-light-purple-c",
  },
  21: { children: "خطای صدور ", className: "color-red-c bg-light-red-c" },
  22: { children: "خطای صدور ", className: "color-red-c bg-light-red-c" },
  100: { children: "استرداد شده", className: "color-pink-c bg-light-pink-c" },
  101: {
    children: "استرداد موفق",
    className: "color-yellow-c bg-light-yellow-c",
  },
};

export const PaymentStatus = {
  1: { children: "پرداخت موفق", className: "bg-light-green-c color-green-c" },
  2: { children: "پرداخت ناموفق", className: "color-red-c bg-light-red-c" },
  3: { children: "پردازش نشده", className: "color-yellow-c bg-light-yellow-c" },
};

export const filterStatusTickets = [
  "همه",
  "جدید",
  "درحال انجام",
  "نیاز به بررسی",
  "انجام شده",
];
export const filterStatusBilit = [
  "همه",
  "Suspend",
  "open for use",
  "Flown",
  "Cancel",
  "Void",
  "Refund",
];

export const TicketStatus = {
  0: { children: "جدید", className: "color-purple-c bg-light-purple-c" },
  1: {
    children: "پاسخ داده" + " شده",
    className: "bg-light-green-c color-green-c",
  },
  2: { children: "بسته", className: "color-yellow-c bg-light-yellow-c" },
};

export const OperatorActivation = {
  0: { children: "غیر فعال", className: "color-yellow-c bg-light-yellow-c" },
  1: { children: "فعال", className: "bg-light-green-c color-green-c" },
  2: { children: "بن", className: "color-red-c bg-light-red-c" },
};

export const persianWeekDays = {
  0: "شنبه",
  1: "یک‌شنبه",
  2: "دوشنبه",
  3: "سه‌شنبه",
  4: "چهارشنبه",
  5: "پنج‌شنبه",
  6: "جمعه",
};

export const pWDays = [
  { value: -1, label: "همه روزها" }, // Select All option
  { value: 0, label: "شنبه" }, // Sunday
  { value: 1, label: "یک‌شنبه" }, // Monday
  { value: 2, label: "دوشنبه" }, // Tuesday
  { value: 3, label: "سه‌شنبه" }, // Wednesday
  { value: 4, label: "چهارشنبه" }, // Thursday
  { value: 5, label: "پنج‌شنبه" }, // Friday
  { value: 6, label: "جمعه" }, // Saturday
];

export const activation = {
  false: { children: "غیرفعال", className: "color-red-c bg-light-red-c" },
  true: { children: "فعال", className: "bg-light-green-c color-green-c" },
};

export const saleStatus = {
  past: {
    children: "تمام شده",
    className: "color-blue-c bg-light-blue-c",
  },
  current: {
    children: "در حال فروش",
    className: "color-green-c bg-light-green-c",
  },
  future: {
    children: "شروع نشده",
    className: "bg-light-yellow-c color-yellow-c",
  },
};
